<script>
    import slider from "shared/Components/slider.vue";
    import login from "forms/login.vue";
    import f9button from "inputs/f9button.vue";
    import { get, getIbeHost } from "shared/Utilities/fetchUtilities";
    import { MemberBaseData } from "shared/Models/memberClasses";
    import { getMember, attachToMemberEvent, getBaseMemberData } from "shared/member";
    import { logout, attachToLoginEvent, attachToLogoutEvent } from "shared/login";
    import { waitForFinalEvent, attach } from "shared/eventBus";
    import { params } from 'shared/query';

    let tabletWidth = 768, pointsTokenUrl = "/F9/GetPointsToken";

    export default {
        props: {
            "reloadOnLogin": Boolean,
            "showSignupSuccess": {
                type: Boolean,
                default: true
            },
            "reloadOnLogout": {
                type: Boolean,
                default: true
            },
            "profileUrl": {
                type: String,
                default: "/FrontierMiles/Profile"
            }
            },
        data () {
            return {
                inPathDD: false,
                logoutVisible: false,
                isNDCLoggedIn:false,
                imageRelativePath: "/Content/responsive/images/",
                member: {
                    isLoggedIn: false
                },
                dataLoaded: false,
                pointsReturnUrl: params()["url-ok"],
                allowLoginSliderClose: true,
                hashEmail: ""
            };
        },
        components: {
            slider,
            login,
            f9button
        },
        mounted () {
            attachToMemberEvent("baseMemberLoaded", event => {
                this.member = event.detail.data;
                this.dataLoaded = true;
                setTimeout(() => this.resizeBackground(), 100);
                this.handlePointsRedirect();
                this.pushHashedEmailIfIsLoggedIn();     
            });

            attachToLoginEvent(event => this.hideLoginSlider());
            
            attachToLogoutEvent(x => this.member = x ? { isLoggedIn: false } : this.member);

            this.$nextTick(() => getBaseMemberData(true, this.getHost()).then(member => this.member = member))
            
            //This makes the background bar reach the right edge of the screen without extending beyond the body width.
            attach("load resize", () => waitForFinalEvent(this.resizeBackground, 100, "window-resize"));

            attach("showDDLoginSlider", event => {
                this.inPathDD = true;
                this.showLoginSlider();
            });
        },
        methods: {
            updateMember(member){
                Object.apply(this.member, member);
            },
            resizeBackground() {
                var pos = this.$el.getBoundingClientRect(),
                    windowWidth = document.documentElement.clientWidth,
                    newWidth = windowWidth - pos.left;
                
                if(windowWidth > tabletWidth) {
                    this.$refs.background.style.width = newWidth + "px";
                } else {
                    this.$refs.background.style.width = "100%";
                }
            },
            showSignupSlider() {
                this.$refs.login.signUpSlider(.5);
            },
            handleUserClick() {
                if(this.member.isLoggedIn) {
                    this.logoutVisible = true;
                } else {
                    this.showLoginSlider();
                }
            },
            keyDownEnterOrSpaceToShowLoginSlider:function(e)
            {
                var code = (e.keyCode ? e.keyCode : e.which); 
                if(code == 13 || code == 32) { //Enter and space keycode
                     this.showLoginSlider();
                }
            },
            showLoginSlider() {
                this.$refs.loginSlider.show();
            },
            hideLoginSlider() {
                this.$refs.loginSlider.hide();
            },
            redirectToProfile() {
                window.location = this.getHost() + this.profileUrl;
            },
            signOut () {
                logout(this.getHost())
                    .then(x => {
                        if(this.reloadOnLogout) {
                            window.location.href = "/";
                        } else {
                            this.logoutVisible = false;
                            Object.apply(this.member, new MemberBaseData());
                        }
                    });
            },
            getHost() {
                return getIbeHost();
            },
            doPointsRedirect() {
                get(this.getHost() + pointsTokenUrl)
                    .then(response => response.text())
                    .then(token => {
                        let char = this.pointsReturnUrl.indexOf("?") > -1 ? "&" : "?";
                        window.location.href = `${this.pointsReturnUrl}${char}token=${encodeURIComponent(token)}`;
                    });
            },
            handlePointsRedirect() {
                if(this.pointsReturnUrl) {
                    if(!this.member.isLoggedIn) {
                        this.allowLoginSliderClose = false;
                        this.$refs.loginSlider.show();
                        attachToLoginEvent(event => this.doPointsRedirect());
                    } else {
                        this.doPointsRedirect();
                    }
                }
            },
            async sha256(messageString) {
                const msgBuffer = new TextEncoder().encode(messageString);
                const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
                const hashArray = Array.from(new Uint8Array(hashBuffer));
                const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
                return hashHex;
            },
            pushHashedEmailIfIsLoggedIn() {
                if (this.member.isLoggedIn && this.member.email !== null && this.member.email !== 'undefined' && this.member.email !== '') {
                    this.sha256(this.member.email).then(result => {
                        this.hashEmail = result;
                        this.isNDCLoggedIn = this.member.isNDCLoggedIn;
                        window.dataLayer = window.dataLayer || [];

                        window.dataLayer.push({
                            "customerInfo": {
                                "add": {},
                                "click": {}
                            }, "email": this.hashEmail } );
                    });
                }
            }
        }
    }
</script>

<template>
  <div class="user-container" v-show="dataLoaded">
    <slider ref="loginSlider" title="ACCOUNT SIGN IN" :can-close="allowLoginSliderClose">
        <login ref="login" slot-scope="{hide}" :hide="hide" :show-signup-success="showSignupSuccess" :reload-on-login="reloadOnLogin" :inPathDD="inPathDD"></login>
    </slider>
    <div class="user-background pointer" :class="{ 'logged-in': member.isLoggedIn }" ref="background" @click="handleUserClick"></div>
    <div v-show="member.isLoggedIn" class="user-logged-in">
        <img :src="member.image" ref="avatar" class="user-avatar pointer" @click="logoutVisible = true" alt="">
        <span ref="logoutToggle" role="button" tabindex="0" class="user-name" @click="logoutVisible = true" 
            @keydown.enter.space.stop.prevent="logoutVisible = !logoutVisible">

            <span>Hi,</span>&nbsp;<span class="first-name" data-cs-mask>{{member.firstName}}</span>&nbsp;<span v-if="!isNDCLoggedIn">| {{member.currentMiles}} mi.</span>
        </span>
        <div class="logout-container vertical center pointer" :class="{ visible: logoutVisible }">
            <div class="logout-text horizontal center around">
                <span class="frontier">FRONTIER Miles</span>
                <span class="sm">sm</span>
                <span class="account">ACCOUNT</span>
            </div>
            <f9button ref="profileButton" @click="redirectToProfile"
                @keydown.tab.stop.prevent="$refs.signOutButton.focus"
                @keydown.esc.stop.prevent="logoutVisible = false" v-if="!isNDCLoggedIn">VIEW PROFILE</f9button>
            <f9button ref="signOutButton" gray @click="signOut"
                @keydown.tab.stop.prevent="$refs.profileButton.focus"
                @keydown.esc.stop.prevent="logoutVisible = false, $refs.logoutToggle.focus()">LOG OUT</f9button><!--TODO FIX KEYBOARD TRAP-->
            <div class="arrow"></div>
        </div>
        <div class="logout-modal" :class="{ visible: logoutVisible }" @click="logoutVisible = false"></div>
    </div>
    <div v-show="!member.isLoggedIn" @click="showLoginSlider" @keydown="keyDownEnterOrSpaceToShowLoginSlider" class="pointer user-not-logged-in" tabindex="0">
        Hi, log in | sign up
    </div>
  </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    @import "~less-mixins";

    .user-container {
        font-size: 12px;
        display: inline-block;
        position: relative;
        
        .user-logged-in {
            margin-top: 5px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            overflow: visible;

            .user-avatar {
                height: 28px;
                z-index: 1;
            }

            .user-name {
                padding-left: 12px;
                white-space: nowrap;
                overflow: visible;
                display: flex;

                .first-name {
                    max-width: 90px;
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }

        .user-background {
            position: absolute;
            left: 0;
            height: 29px;
            width: 100%;

            &.logged-in {
                background-color: rgba(255, 255, 255, .1);
                top: 4px;
                border-top-left-radius: 14px;
                border-bottom-left-radius: 14px;
            }

            &:not(.logged-in) {
                border-bottom: 1px solid rgba(255, 255, 255, .1);
                top: -8px;
            }
        }

        .user-not-logged-in {
            display: inline-block;
            white-space: nowrap;
            overflow: visible;
        }

        .logout-container {
            z-index: 1001;
            position: absolute;
            right: 4px;
            padding: 13px 10px;
            top: 50px;
            width: 366px;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            background-image: linear-gradient(182deg, #3b4e55 0%, #576e77 100%);
            height: 0;
            opacity: 0;
            display: flex;
            transition: height .1s linear;
            box-sizing: border-box;
            pointer-events: none;
            max-width: 96vw;
            font-size: 25px;
            cursor: default;

            * {
                transition: height .1s linear;
                cursor: default;
            }
            
            &:not(.visible) * {
                height: 0px;
            }

            &.visible {
                pointer-events: initial;
                height: auto;
                opacity: 1;
            }

            .logout-text {
                .my {
                    height: 30px;
                    margin-top: 16px;
                    padding-right: 5px;
                }

                .frontier {
                    font-size: 20px;
                    font-style: italic;
                    font-weight: 700;
                    margin-left: -5px;
                }

                .sm {
                    font-size: 7px;
                    margin-bottom: 10px;
                }

                .account {
                    padding-left: 2px;
                    font-size: 20px;
                    font-weight: 700;
                }
            }

            .arrow {
                position: absolute; 
                right: 40px;
                top: -20px;

                .arrow-up(30px, 20px, #3b4e55);
            }

            #logout {
                background-image: linear-gradient(182deg, #3b4e55 0%, #576e77 100%);
            }
        }

        .logout-modal {
            background-color: transparent;
            display: none;
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;

            &.visible {
                display: block;
            }
        }
    }

    @media @tablet {
        .user-container {
            .user-logged-in {
                .user-background {
                    width: 100%;
                    right: 0px;
                }

                .user-name {
                    padding-right: 15px;
                }
            }
            
            .user-not-logged-in {
                padding-right: 15px;
            }
        }
    }

    @media @mobile {
        .user-container {
            font-size: 11px;

            .user-logged-in {
                .user-name {
                    /* padding-right: 5px; */
                    padding-left: 5px;
                }
            }
        }
    }

    @media only screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        .user-container {
            .user-logged-in {
                align-items: inherit;

                .user-name {
                    padding-top: 2.5%;
                }

                .logout-container {
                    .logout-text {
                        .my {
                            margin-top: 0;
                        }
                    }
                }
            }
        }
    }
</style>
